import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

const mapCallableError = (error, notDeployedHint) => {
  console.error(notDeployedHint, error)
  const code = typeof error?.code === 'string' ? error.code.replace('functions/', '') : ''
  if (code === 'not-found' && !error?.message?.includes('Матеріал') && !error?.message?.includes('Тег')) {
    return {
      ok: false,
      code,
      message: notDeployedHint,
    }
  }
  const details =
    typeof error?.details === 'string'
      ? error.details
      : error?.details && typeof error.details === 'object' && typeof error.details.message === 'string'
        ? error.details.message
        : ''
  const raw = [code, error?.message, details].filter(Boolean).join(' — ')
  return {
    ok: false,
    code,
    message: raw || getCallableErrorMessage(error),
  }
}

export const listBlogMaterials = async (payload = {}) => {
  try {
    const callable = functions.httpsCallable('listBlogMaterials')
    const result = await callable(payload)
    return {
      ok: true,
      materials: Array.isArray(result?.data?.materials) ? result.data.materials : [],
    }
  } catch (error) {
    return mapCallableError(
      error,
      'listBlogMaterials is not deployed. Run: firebase deploy --only functions:listBlogMaterials'
    )
  }
}

export const getBlogMaterial = async (materialId) => {
  try {
    const callable = functions.httpsCallable('getBlogMaterial')
    const result = await callable({ materialId })
    return {
      ok: true,
      material: result?.data?.material || null,
    }
  } catch (error) {
    return mapCallableError(
      error,
      'getBlogMaterial is not deployed. Run: firebase deploy --only functions:getBlogMaterial'
    )
  }
}

export const upsertBlogMaterialMeta = async (payload) => {
  try {
    const callable = functions.httpsCallable('upsertBlogMaterialMeta')
    const result = await callable(payload)
    return {
      ok: true,
      material: result?.data?.material || null,
      softWarn: result?.data?.softWarn === true,
    }
  } catch (error) {
    return mapCallableError(
      error,
      'upsertBlogMaterialMeta is not deployed. Run: firebase deploy --only functions:upsertBlogMaterialMeta'
    )
  }
}

export const listBlogTags = async () => {
  try {
    const callable = functions.httpsCallable('listBlogTags')
    const result = await callable({})
    return {
      ok: true,
      tags: Array.isArray(result?.data?.tags) ? result.data.tags : [],
    }
  } catch (error) {
    return mapCallableError(
      error,
      'listBlogTags is not deployed. Run: firebase deploy --only functions:listBlogTags'
    )
  }
}

export const upsertBlogTag = async (payload) => {
  try {
    const callable = functions.httpsCallable('upsertBlogTag')
    const result = await callable(payload)
    return {
      ok: true,
      tag: result?.data?.tag || null,
    }
  } catch (error) {
    return mapCallableError(
      error,
      'upsertBlogTag is not deployed. Run: firebase deploy --only functions:upsertBlogTag'
    )
  }
}

export const listBlogAuthors = async () => {
  try {
    const callable = functions.httpsCallable('listBlogAuthors')
    const result = await callable({})
    return {
      ok: true,
      authors: Array.isArray(result?.data?.authors) ? result.data.authors : [],
    }
  } catch (error) {
    return mapCallableError(
      error,
      'listBlogAuthors is not deployed. Run: firebase deploy --only functions:listBlogAuthors'
    )
  }
}

export const saveBlogDraft = async (payload) => {
  try {
    const callable = functions.httpsCallable('saveBlogDraft')
    const result = await callable(payload)
    return {
      ok: true,
      material: result?.data?.material || null,
      softWarn: result?.data?.softWarn === true,
    }
  } catch (error) {
    return mapCallableError(
      error,
      'saveBlogDraft is not deployed. Run: firebase deploy --only functions:saveBlogDraft'
    )
  }
}

export const setBlogPublication = async (payload) => {
  try {
    const result = await functions.httpsCallable('setBlogPublication')(payload)
    return { ok: true, material: result?.data?.material || null }
  } catch (error) {
    return mapCallableError(error, 'setBlogPublication is not deployed')
  }
}

export const deleteBlogMaterial = async (payload) => {
  try {
    const result = await functions.httpsCallable('deleteBlogMaterial')(payload)
    return { ok: result?.data?.deleted === true, materialId: result?.data?.materialId }
  } catch (error) {
    return mapCallableError(error, 'Не вдалося видалити матеріал.')
  }
}
